Browser = require '@trello/browser'
track = require 'debug/track'
WarningBannerView = require 'views/header/warning-banner-view'

t = require('views/internal/teacup-with-helpers')('browser_will_be_unsupported')

template = t.renderable ->
  t.p '.u-bottom', ->
    switch Browser.browserStr
      when 'explorer'
        t.format 'trello-is-ending-support-for-ie'
        t.text ' '
        t.format 'please-use-edge-or-the-desktop-client', {
          edge: 'https://support.microsoft.com/en-us/help/12435/windows-10-upgrade-faq',
          desktop: 'https://trello.com/platforms'
        }

      when 'safari'
        t.format 'this-version-of-safari-is-not-supported'
        t.text ' '
        t.format 'please-upgrade-to-a-supported-version', {
          url: 'https://support.apple.com/downloads/safari'
        }

      when 'chrome'
        t.format 'this-version-of-chrome-is-not-supported'
        t.text ' '
        t.format 'please-upgrade-to-a-supported-version', {
          url: 'https://www.google.com/chrome'
        }

      when 'edge'
        t.format 'this-version-of-edge-is-not-supported'
        t.text ' '
        t.format 'please-upgrade-to-a-supported-version', {
          url: 'https://www.microsoft.com/en-us/windows/microsoft-edge'
        }

      when 'firefox'
        t.format 'this-version-of-firefox-is-not-supported'
        t.text ' '
        t.format 'please-upgrade-to-a-supported-version', {
          url: 'https://www.firefox.com/'
        }

      else
        # They're using a browser we don't recognize e.g. Vivaldi
        t.format 'this-browser-is-not-supported'
        t.text ' '
        t.format 'you-may-need-to-upgrade-or-switch-to-a-supported-browser'

module.exports = class BrowserWillBeUnsupportedView extends WarningBannerView
  events:
    'click a': (e) ->
      track("Unsupported Browser Banner", "Clicked Upgrade", Browser.browserVersionStr)

  render: ->
    @$el.html(template())
    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/browser-will-be-unsupported-view.coffee